import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';
// import { coreActions } from 'app-components/flux/core-actions';
import { combineActions, handleActions } from 'redux-actions';
import { resourceUndoUpserters, resourceUpserters } from '../core';
import * as actions from './freeToSpendActions';
import { type FreeToSpendProps, type FreeToSpendPropsImmu, mkFreeToSpendStore } from './freeToSpendTypes';

const freeToSpendReducer = handleActions<
  QcsSyncResourceStore<FreeToSpendPropsImmu>,
  // | coreActions.SanitizeAction
  | ReturnType<typeof actions.getFreeToSpend>
  | ReturnType<typeof actions.getFreeToSpendSuccess>
  | ReturnType<typeof actions.getFreeToSpendFailure>
  | ReturnType<typeof actions.createFreeToSpend>
  | ReturnType<typeof actions.createFreeToSpendSuccess>
  // | ReturnType<typeof actions.createFreeToSpendFailure>
  | ReturnType<typeof actions.updateFreeToSpend>
  | ReturnType<typeof actions.updateFreeToSpendSuccess>
  | ReturnType<typeof actions.updateFreeToSpendOptimistic>
  // | ReturnType<typeof actions.updateFreeToSpendFailure>
  | ReturnType<typeof actions.updateFreeToSpendsBump>
  | ReturnType<typeof actions.deleteFreeToSpend>
  | ReturnType<typeof actions.deleteFreeToSpendSuccess>
  // | ReturnType<typeof actions.deleteFreeToSpendFailure>
  // | ReturnType<typeof actions.createPlannedSpending>
  | ReturnType<typeof actions.updatePlannedSpending>
  // | ReturnType<typeof actions.updatePlannedSpendingSuccess>
  // | ReturnType<typeof actions.updatePlannedSpendingFailure>
  // | ReturnType<typeof actions.deletePlannedSpending>
  // | ReturnType<typeof actions.deletePlannedSpendingSuccess>
  // | ReturnType<typeof actions.deletePlannedSpendingFailure>
>(
  {
    [actions.createFreeToSpend.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResource(state, freeToSpend, true, true),
    [actions.createFreeToSpendSuccess.type]: (state, { payload: freeToSpend }) => {
      return resourceUpserters.upsertResource(state, freeToSpend, true, false);
    },

    [actions.updateFreeToSpend.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateFreeToSpend),

    [actions.updateFreeToSpendOptimistic.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResource(state, freeToSpend),

    [actions.updateFreeToSpendSuccess.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResource(state, freeToSpend),

    [actions.updateFreeToSpendsBump.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResources(state, freeToSpend),

    [actions.updatePlannedSpending.type]: (state) => state,

    [actions.deleteFreeToSpend.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createFreeToSpend),
    [actions.deleteFreeToSpendSuccess.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResource(state, freeToSpend),

    [combineActions(
      actions.createFreeToSpendFailure,
      actions.updateFreeToSpendFailure,
      actions.deleteFreeToSpendFailure,
    ).toString()]: (state: QcsSyncResourceStore<FreeToSpendProps>, { payload: error }: any) => {
      return resourceUpserters.resetResources(state, error);
    },

    [actions.getFreeToSpend.type]: (state) => state.merge({ isLoading: true }),
    [actions.getFreeToSpendSuccess.type]: (state, { payload: resources }) => {
      const newState = resourceUpserters.upsertResources(state, resources);
      return newState;
    },
    [actions.getFreeToSpendFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  mkFreeToSpendStore(),
);
export default freeToSpendReducer;
